import { useEffect, useRef } from 'react';
import { storeTokens } from '../services/keycloak';

export default function OAuthCallback() {
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const params = new URLSearchParams(window.location.hash.substring(1));
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token') ?? '';
    const idToken = params.get('id_token') ?? '';

    if (!accessToken) {
      window.location.replace('/');
      return;
    }

    storeTokens(accessToken, refreshToken, idToken);

    const redirectTo = sessionStorage.getItem('loginRedirect') || '/';
    sessionStorage.removeItem('loginRedirect');
    // Full page navigation so AuthProvider re-initialises with the token already in sessionStorage
    window.location.replace(redirectTo);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'var(--bg-primary)',
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          border: '3px solid transparent',
          borderTopColor: 'var(--accent)',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
    </div>
  );
}
